export const setSecureUser = (userData) => {
  try {
    const enc = btoa(encodeURIComponent(JSON.stringify(userData)));
    localStorage.setItem("user", enc);
  } catch (error) {
    console.error("Error securing user logging:", error);
    localStorage.setItem("user", JSON.stringify(userData));
  }
};

export const getSecureUser = () => {
  const data = localStorage.getItem("user");
  if (!data) return null;
  try {
    return JSON.parse(decodeURIComponent(atob(data)));
  } catch (e) {
    try {
      return JSON.parse(data);
    } catch (err) {
      return null;
    }
  }
};
